import React from 'react';
import { benefits } from '../data/content';
import { toneAt } from '../utils/iconTones';
export function BenefitsSection() {
  const [lead, ...rest] = benefits;
  return <section className="w-full bg-cream-100 px-6 pb-10 sm:pb-12" aria-labelledby="benefits-title" data-id="element-1" data-mp="3iq805z9nyqa7">
      <div className="mx-auto max-w-5xl" data-id="element-2" data-mp="3npb75p97f6kt">
        <h2 id="benefits-title" className="text-center font-display text-3xl font-bold uppercase leading-[1.08] tracking-tight text-forest-800 sm:text-4xl" data-id="element-3" data-mp="3no9kenitsvn9">
          With This System, You Will Be Able To:
        </h2>

        <div className="mt-6 grid gap-3 lg:grid-cols-3" data-id="element-4" data-mp="3dor2ecmh7jxu">
          <article className="flex flex-col justify-center rounded-2xl bg-forest-800 p-6 lg:row-span-2" data-id="element-5" data-mp="2zsnk9hovn21q">
            <h3 className="flex items-center gap-3 font-display text-xl font-bold uppercase leading-tight text-cream-50 sm:text-2xl" data-id="element-6" data-mp="34qyv9vqwrilj">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-ember-400/15" data-id="element-7" data-mp="xy4pvcadbq9f">
                <lead.icon className="h-[1.35rem] w-[1.35rem] text-ember-400" strokeWidth={2} aria-hidden="true" data-id="element-8" data-mp="2bexkd4rlkqtq" />
              </span>
              {lead.title}
            </h3>
            <p className="mt-2.5 text-sm leading-relaxed text-cream-100/80 sm:text-base" data-id="element-9" data-mp="27bhmy67pemfz">
              {lead.description}
            </p>
          </article>

          <div className="grid gap-3 sm:grid-cols-2 lg:col-span-2" data-id="element-10" data-mp="2g6xhyqk737n5">
            {rest.map(({
            icon: Icon,
            title,
            description
          }, index) => <article key={title} className="flex h-full flex-col rounded-2xl border border-cream-300/60 bg-white p-5" data-id="element-11" data-mp="1si4qb6alvlyc" data-mpi={index}>
                <h3 className="flex items-center gap-3 text-[0.95rem] font-semibold leading-snug text-forest-900" data-id="element-12" data-mp="22g2exuwdnkrh">
                  <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${toneAt(index + 1).bg}`} data-id="element-13" data-mp="1xe3bym4jupv2">
                    <Icon className={`h-[1.25rem] w-[1.25rem] ${toneAt(index + 1).fg}`} strokeWidth={2} aria-hidden="true" data-id="element-14" data-mp="38wny155e0jlw" />
                  </span>
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-forest-600/90" data-id="element-15" data-mp="3pwqoxzmg3lyt">{description}</p>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}